// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__movable--Bj1OU {
  cursor: move;
  padding: 8px 24px;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__movable--Bj1OU:hover {
  background: #f0f0f0;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__container--R7zgF li {
  background: white;
  list-style-type: none;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__container--R7zgF .src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__checkBoxWrapper--Ue_l7 {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__container--R7zgF .src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__columnInfo--DW1Ov {
  cursor: move;
  padding: 8px 24px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  gap: 15px;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__container--R7zgF .src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__columnInfo--DW1Ov:hover {
  background: #f0f0f0;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__container--R7zgF .src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__columnInfo--DW1Ov.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__disabled--gVmT6 {
  cursor: pointer;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__freezeContainer--aZnOe {
  cursor: move;
  padding: 8px 24px;
  display: flex;
  gap: 8px;
  align-items: center;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__freezeContainer--aZnOe:hover {
  background: #f0f0f0;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__freezeLabel--tRx26 {
  color: #e43d00;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
}
.src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__freezeLine--bTk0y {
  flex: 1;
  height: 1px;
  background-color: #e43d00;
}
`, "",{"version":3,"sources":["webpack://./src/components/tables/ColumnsSettings/ColumnSettingsList/ColumnSettingsList.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;AACF;AAAE;EACE,mBAAA;AAEJ;AAEA;EAEI,iBAAA;EACA,qBAAA;AADJ;AAFA;EAOI,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAPA;EAPE,YAAA;EACA,iBAAA;EAoBE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AArBE;EACE,mBAAA;AAuBJ;AAAI;EACE,eAAA;AAEN;AAGA;EAhCE,YAAA;EACA,iBAAA;EAiCA,aAAA;EACA,QAAA;EACA,mBAAA;AAAF;AAlCE;EACE,mBAAA;AAoCJ;AAEA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;AAGA;EACE,OAAA;EACA,WAAA;EACA,yBAAA;AADF","sourcesContent":[".movable {\n  cursor: move;\n  padding: 8px 24px;\n  &:hover {\n    background: #f0f0f0;\n  }\n}\n\n.container {\n  li {\n    background: white;\n    list-style-type: none;\n  }\n\n  .checkBoxWrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n  }\n\n  .columnInfo {\n    .movable();\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    flex-direction: row;\n    gap: 15px;\n    &.disabled {\n      cursor: pointer;\n    }\n  }\n}\n\n.freezeContainer {\n  .movable();\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n@freezeColor: #e43d00;\n\n.freezeLabel {\n  color: @freezeColor;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 160%;\n}\n\n.freezeLine {\n  flex: 1;\n  height: 1px;\n  background-color: @freezeColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"movable": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__movable--Bj1OU`,
	"container": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__container--R7zgF`,
	"checkBoxWrapper": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__checkBoxWrapper--Ue_l7`,
	"columnInfo": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__columnInfo--DW1Ov`,
	"disabled": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__disabled--gVmT6`,
	"freezeContainer": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__freezeContainer--aZnOe`,
	"freezeLabel": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__freezeLabel--tRx26`,
	"freezeLine": `src-components-tables-ColumnsSettings-ColumnSettingsList-ColumnSettingsList-module__freezeLine--bTk0y`
};
export default ___CSS_LOADER_EXPORT___;
